<app-modal [isOpen]="isOpen" modalTitle="View Document" [maxWidth]="'max-w-[58.3rem]'" (close)="onClose()">
  <div header-actions class="flex items-center gap-1 flex-wrap">
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Zoom In"
      (click)="zoomIn()">
      <i class="fas fa-search-plus"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Zoom Out"
      (click)="zoomOut()">
      <i class="fas fa-search-minus"></i>
    </button>
    <span class="text-white/50 text-xs mx-1">|</span>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Rotate 90°"
      (click)="rotate90()">
      <i class="fas fa-undo"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Rotate 180°"
      (click)="rotate180()">
      <i class="fas fa-sync-alt"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Rotate 270°"
      (click)="rotate270()">
      <i class="fas fa-redo"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Rotate 360°"
      (click)="rotate360()">
      <i class="fas fa-circle-notch"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Rotate 0°"
      (click)="rotate0()">
      <i class="fas fa-dot-circle"></i>
    </button>
    <span class="text-white/50 text-xs mx-1">|</span>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Download"
      (click)="onDownload()" [disabled]="!imageUrl">
      <i class="fas fa-download"></i>
    </button>
    <button type="button" class="p-2 text-white/90 hover:text-white rounded transition-colors" title="Print"
      (click)="onPrint()" [disabled]="!imageUrl">
      <i class="fas fa-print"></i>
    </button>
  </div>
  <div
    class="w-full aspect-[1.25] max-w-[min(90vmin,930px)] mx-auto flex flex-col items-center justify-center bg-slate-200/50 rounded overflow-hidden document-viewer-square">
    <div *ngIf="isLoading" class="py-12 flex flex-col items-center gap-3 text-slate-600">
      <i class="fas fa-spinner fa-spin text-3xl"></i>
      <span class="text-sm font-medium">Loading document...</span>
    </div>
    <div *ngIf="(errorMessage || loadError) && !isLoading" class="py-12 px-4 text-center text-red-600">
      <i class="fas fa-exclamation-circle text-2xl mb-2"></i>
      <p class="text-sm font-medium">{{ loadError || errorMessage }}</p>
    </div>
    <div *ngIf="documentContentType === 'application/pdf' && imageUrl && !isLoading && !errorMessage"
      class="w-full h-full flex flex-col document-viewer-content">
      <div class="w-full flex-1 min-h-[550px] bg-slate-100 overflow-hidden relative">
        <object [data]="imageUrl" type="application/pdf" class="absolute inset-0 w-full h-full border-0">
          <iframe [src]="imageUrl" title="Document PDF"
            class="absolute inset-0 w-full h-full border-0 rounded overflow-hidden" allow="autoplay">
            Your browser does not support PDF viewing.
            <a [href]="imageUrl" (click)="openInNewTab(); $event.preventDefault()">View Document</a>
          </iframe>
        </object>
      </div>
    </div>
    <div *ngIf="imageUrl && documentContentType !== 'application/pdf' && !isLoading && !errorMessage && !imageLoadError"
      class="p-4 overflow-auto w-full h-full flex items-center justify-center document-viewer-content">
      <img [src]="imageUrl" alt="Document"
        class="max-w-full max-h-full w-auto h-auto object-contain transition-transform duration-200 document-image"
        [style.transform]="imageTransform" (error)="onImageError()" />
    </div>
    <div *ngIf="imageUrl && documentContentType !== 'application/pdf' && !isLoading && !errorMessage && imageLoadError"
      class="py-12 px-4 text-center text-slate-600">
      <i class="fas fa-file-image text-4xl mb-3 text-slate-400"></i>
      <p class="text-sm font-medium mb-2">This image could not be displayed in the browser.</p>
      <p class="text-xs text-slate-500 mb-4">Use Download or Open in new tab to view the file.</p>
      <div class="flex justify-center gap-3">
        <button type="button" class="px-4 py-2 rounded bg-[var(--primary)] text-white text-sm font-medium hover:opacity-90"
          (click)="onDownload()">
          <i class="fas fa-download mr-2"></i>Download
        </button>
        <button type="button" class="px-4 py-2 rounded border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50"
          (click)="openInNewTab()">
          <i class="fas fa-external-link-alt mr-2"></i>Open in new tab
        </button>
      </div>
    </div>
  </div>
</app-modal>